import { useCallback } from "react";
import { ModelElementType } from "components/entities";
import { useMainStateStore } from "@/components/main/stores/mainStateStore";
import { showNotificationGlobal } from "@/stores/useNotificationStore";
import { updateModelAppearance } from "./ModelServices";

export function useModelAppearanceUpdate(model: ModelElementType | null) {
  const patchModel = useMainStateStore((s) => s.patchModel);
  return useCallback(
    async (appearance: { color?: string; icon?: number }) => {
      if (!model) return;
      const rollback = patchModel(model.model_id, appearance);
      if (!(await updateModelAppearance(model.model_id, appearance))) {
        rollback();
        showNotificationGlobal("Failed to update model appearance", "error");
      }
    },
    [model, patchModel],
  );
}
